import { style, types } from 'typestyle';

export { classes, keyframes } from 'typestyle';

export type Style = types.NestedCSSProperties;

export function cssClass(name: string, ...styles: Style[]): string {
  return style(...styles, {
    $debugName: `datacatalog_${name}`,
    $unique: true,
  });
}
